<template>
  <div class="receipt-transcation-details">
    <div class="receipt-transcation-details-row">
      <div class="receipt-transcation-details-row-title">
        <p>{{ $t("receipt.date") }}</p>
      </div>
      <div class="receipt-transcation-details-row-value">
        <span>{{ transactionDate }}</span>
      </div>
    </div>
    <div class="receipt-transcation-details-row">
      <div class="receipt-transcation-details-row-title">
        <span>{{ $t("receipt.transactionId") }}</span>
      </div>
      <div class="receipt-transcation-details-row-value">
        <span>#{{ orderNo }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ReceiptTransactionDetails",
  props: {
    paymentInfo: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      dialogVisible: false,
    };
  },
  computed: {
    orderNo() {
      return this.paymentInfo.orderNo.split("# ").pop();
    },
    transactionDate() {
      return new Date(this.paymentInfo.created).toLocaleString("en-GB", {
        day: "2-digit",
        year: "numeric",
        month: "short",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.receipt-transcation-details {
  display: block;
  margin-top: 20px;
  padding: 0 12px;

  &-row {
    display: flex;
    justify-content: space-between;
    max-height: 30px;
    align-items: center;

    &-title {
      color: #b5b5b5;
      font-family: "Raleway Regular", serif;
      font-size: 16px;
      line-height: 24px;
      text-transform: capitalize;
    }

    &-value {
      color: #2d2e2f;
      font-family: "Raleway Regular", serif;
      font-size: 16px;
      line-height: 24px;
      font-feature-settings: "pnum" on, "lnum" on;
    }
  }
}
</style>
